import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    title: 'SHOT BAND',
    loading: 'Loading SHOT BAND...',

    // BandHero — member
    heroWelcome: 'Welcome to',
    heroMemberBadge: 'SHOT BAND member',
    heroDaysLeftOne: '{{count}} day left',
    heroDaysLeftFew: '{{count}} days left',
    heroDaysLeftMany: '{{count}} days left',
    heroDaysLeftZero: 'Membership ends today',
    heroRenewButton: 'Renew',
    // BandHero — non-member
    heroOfferTitlePrefix: 'The',
    heroOfferTitleSuffix: 'top-up turns the club on — here or in any top-up.',
    heroOfferBody: 'Cashback up to 4% — it grows with your level — daily quests and a shot at the knife raffle.',
    heroOfferFinePrint: 'The whole amount lands on your game balance. Spend it on cases, contracts, games and upgrades however you like.',
    heroJoinButton: 'Join for',
    heroHowItWorks: 'How it works',

    // BandRulesSheet
    rulesTitle: 'How SHOT BAND works',
    rule1Prefix: 'Top up ',
    rule1Suffix: " in one payment — you're in SHOT BAND for 28 days. The coins land on your balance as usual.",
    rule1Title: 'Joining SHOT BAND',
    rule2Title: 'Cashback up to 4%',
    rule2: 'Every coin game pays cashback back in sparks. The rate grows with your level — 1% at level 10, 4% at level 100. Claim it every 7 days.',
    rule3Title: 'Cases for sparks',
    rule3Prefix: 'Sparks ',
    rule3Suffix: ' open SHOT BAND cases — skins all the way up to knives.',
    rule4Title: 'Quests and streak',
    rule4Prefix: 'Daily quests earn ',
    rule4Mid: '. Keep a 7-day streak — get +10 ',
    rule4Suffix: ' as a bonus.',
    rule5Title: 'Weekly knife raffle',
    rule5Prefix: 'Every week we raffle a knife. Invest your ',
    rule5Suffix: ' — more tickets, higher chance.',
    rule6Title: 'Daily race',
    rule6: 'Wager the most coins before midnight (MSK) and take the day’s skin. Every day, a new prize.',
    rule7Title: 'Free cases for turnover',
    rule7: 'Your daily turnover opens shelf cases for free — the more you play, the richer the free case. Up to every case, every day.',

    // BandTicketSheet
    ticketSheetTitleJoin: 'Join SHOT BAND',
    ticketSheetTitleRenew: 'Renew SHOT BAND',
    ticketSheetTopupNotePrefix: 'Your balance is credited with',
    ticketSheetTopupNoteSuffix: 'right away — the club comes as a gift.',
    ticketSheetRenewDisclaimer: 'Renewal adds 28 days to your current membership term.',
    ticketSheetRenewTooEarly: 'Renewal opens a day before your membership ends — come back closer to that date.',
    ticketSheetBuyButton: 'Pay',
    ticketSheetLoadingProviders: 'Loading payment methods...',
    ticketSheetNoProviders: 'No payment methods available right now.',
    ticketSheetErrorTitle: 'Could not create the invoice',
    ticketSheetErrorHint: 'Try again or pick another method',
    ticketSheetLoadErrorGeneric: 'Failed to load payment methods.',
    ticketSheetPriceUnavailable: 'Price unavailable for this payment method — try another one.',
    ticketSheetCardConfirmTitle: 'Confirm payment',
    ticketSheetCardConfirmMessage: 'Charge {{amount}} from {{card}} to join SHOT BAND?',
    ticketSheetCardConfirmOk: 'Pay',
    ticketSheetCardPending: 'Click is still confirming the payment — your membership will switch on automatically.',
    ticketSheetCardErrorTitle: 'Payment did not go through',
    ticketSheetCardErrorHint: 'Try again; if the money left your card, contact support',

    // BandCashback
    cashbackBalanceLabel: 'Club balance',
    cashbackCoinsLabel: 'Sparks',
    cashbackTicketsLabel: 'Tickets',
    cashbackNextPayoutLabel: 'Next payout:',
    mechanicNameCase: 'Cases',
    mechanicNameBattle: 'Battles',
    mechanicNameRushMid: 'Rush Mid',
    mechanicNameRoulette: 'Roulette',
    mechanicNameUpgrade: 'Upgrades',
    mechanicNameContract: 'Contracts',
    cashbackChipPrefix: 'cashback',
    cashbackChipLocked: 'cashback from lvl {{level}}',
    cashbackSpendButton: 'Spend',
    cashbackInvestButton: 'Invest',
    cashbackClaimReadyLabel: 'Cashback ready:',
    cashbackClaimButton: 'Claim',
    cashbackTimerLabel: 'in',
    cashbackUnitDay: 'd',

    // BandStreak
    streakDayLabel: 'Day {{day}} of 7',
    streakHint: '{{days}} days in a row — bonus',

    // BandFreeCases
    freeCasesTitle: 'Free case',
    freeCasesTurnoverLabel: 'Turnover today',
    freeCasesNextHintPrefix: 'Wager',
    freeCasesNextHintSuffix: "more and you'll open it for free",
    freeCasesReadyHint: 'Free to open — go!',
    freeCasesAllClaimed: 'All free opens for today are spent — new ones after the reset',
    freeCasesTimerBurnOpen: 'The free open burns at the reset',
    freeCasesTimerBurnProgress: 'Turnover progress burns at the reset',
    freeCasesTimerPlain: 'Day resets in',
    freeCasesTimerNew: 'New free opens in',
    freeCasesOpenFreeButton: 'Open',
    freeCasesRulesTitle: 'Free case rules',
    freeCasesRulesWagerTitle: 'Play for coins',
    freeCasesRulesWagerBody: 'Every coin game counts into your daily turnover — cases, battles, upgrades, contracts, Rush Mid, roulette.',
    freeCasesRulesOpenTitle: 'Reach the threshold — open for free',
    freeCasesRulesOpenBody: 'Each case has its own turnover threshold. Reached it — the club pays for the open. One free open per case per day.',
    freeCasesRulesResetTitle: 'Everything burns at midnight',
    freeCasesRulesResetBody: 'At midnight (MSK) the day resets: turnover progress and unclaimed free opens burn. Next day — from zero.',

    // BandQuests
    questsTitle: 'Daily quests',
    questsResetLabel: 'New quests in',
    questClaimButton: 'Claim',
    questsLockedJoinButton: 'Join',
    questGenericTitle: 'Daily quest',
    questCompletedToastOverline: 'Quest complete!',
    questGenericUnit: '',

    quest_open_3_cases_2500_prefix: 'Open 3 cases worth',
    quest_open_3_cases_2500_suffix: 'or more',
    quest_open_3_cases_2500_unit: 'cases',
    quest_rush_3_matches_prefix: 'Play 3 Rush Mid matches',
    quest_rush_3_matches_unit: 'matches',
    quest_open_band_case_prefix: 'Open a SHOT BAND case',
    quest_open_band_case_unit: 'case',
    quest_wager_25k_prefix: 'Wager',
    quest_wager_25k_suffix: '',
    quest_battles_2_5k_prefix: 'Play 2 case battles with an entry of',
    quest_battles_2_5k_suffix: 'or more',
    quest_battles_2_5k_unit: 'battles',
    quest_upgrades_3_2500_prefix: 'Make 3 upgrades worth',
    quest_upgrades_3_2500_suffix: 'or more',
    quest_upgrades_3_2500_unit: 'upgrades',
    quest_contract_10k_prefix: 'Complete a contract worth',
    quest_contract_10k_suffix: 'or more',
    quest_contract_10k_unit: 'contract',
    quest_win_battle_prefix: 'Win a case battle',
    quest_win_battle_unit: 'battle',
    quest_win_upgrade_prefix: 'Win an upgrade',
    quest_win_upgrade_unit: 'upgrade',
    quest_open_case_12500_prefix: 'Open a case worth',
    quest_open_case_12500_suffix: 'or more',
    quest_open_case_12500_unit: 'case',
    quest_open_5_cases_1000_prefix: 'Open 5 cases worth',
    quest_open_5_cases_1000_suffix: 'or more',
    quest_open_5_cases_1000_unit: 'cases',
    quest_roulette_play_prefix: 'Play a roulette round',
    quest_roulette_play_unit: 'round',
    quest_contracts_25k_sum_prefix: 'Complete contracts worth',
    quest_contracts_25k_sum_suffix: 'in total',
    quest_upgrades_15k_sum_prefix: 'Make upgrades worth',
    quest_upgrades_15k_sum_suffix: 'in total',
    quest_rush_5_matches_prefix: 'Play 5 Rush Mid matches',
    quest_rush_5_matches_unit: 'matches',
    quest_wager_50k_prefix: 'Wager',
    quest_wager_50k_suffix: '',
    quest_wager_10k_battles_prefix: 'Wager',
    quest_wager_10k_battles_suffix: 'in case battles',
    quest_wager_10k_rush_prefix: 'Wager',
    quest_wager_10k_rush_suffix: 'in Rush Mid',
    quest_wager_10k_roulette_prefix: 'Wager',
    quest_wager_10k_roulette_suffix: 'in roulette',
    quest_wager_100k_prefix: 'Wager',
    quest_wager_100k_suffix: '',
    quest_rush_mid_win_prefix: 'Win a Rush Mid match',
    quest_rush_mid_win_unit: 'win',
    quest_big_drop_25k_prefix: 'Drop an item worth over',
    quest_big_drop_25k_suffix: 'from a case',
    quest_big_drop_25k_unit: 'item',
    quest_risky_upgrade_35_prefix: 'Win an upgrade with odds of 35% or lower',
    quest_risky_upgrade_35_unit: 'upgrade',
    quest_covert_drop_prefix: 'Drop a Covert item from a case',
    quest_covert_drop_unit: 'item',

    // BandRaceSection
    raceTitle: 'Daily race',
    raceEmpty: 'No race today — check back later',
    rulesLinkLabel: 'Rules',
    raceRulesTitle: 'Daily race rules',
    raceRulesPlayTitle: 'How to win',
    raceRulesPlayBody: 'Play anything on SHOT — cases, upgrades, contracts, battles, Rush Mid, roulette. The coins you spend on games count: the biggest daily turnover wins.',
    raceRulesPrizeTitle: 'The prize',
    raceRulesPrizeBody: 'A new skin every day. At midnight (MSK) it goes to the #1 player and lands straight in their inventory.',
    raceRulesMembersTitle: 'Members only',
    raceRulesMembersBody: 'The race is for SHOT BAND members. Your play counts automatically — nothing to activate.',
    raffleRulesTitle: 'Weekly raffle rules',
    raffleRulesTicketsTitle: 'Earn tickets',
    raffleRulesTicketsBodyPrefix: 'Complete daily quests to earn raffle tickets',
    raffleRulesTicketsBodySuffix: '',
    raffleRulesChanceTitle: 'Invest to raise your chance',
    raffleRulesChanceBody: 'Invest tickets into the round — the more you invest, the higher your chance. Invested tickets are not returned, adding more is always allowed.',
    raffleRulesFinalTitle: 'The final',
    raffleRulesFinalBody: 'The round runs for a week. The winner is drawn at random and the skin lands straight in their inventory.',
    racePrizeLabel: "Today's prize",
    raceYourPlace: 'Your place',
    raceParticipantsLabel: 'Playing',
    raceNotWagered: 'Play anything today to join the race',

    // BandRaffleSection
    raffleTitle: 'Weekly raffle',
    raffleEmpty: 'No raffle running this week',
    raffleMyInvestedLabel: 'Invested',
    raffleParticipantsLabel: 'Playing',
    raffleParticipantOne: 'participant',
    raffleParticipantFew: 'participants',
    raffleParticipantMany: 'participants',
    raffleInvestButton: 'Invest',
    raffleGoToQuestsButton: 'Go to quests',
    raffleEndedButton: 'Round ended',
    raffleWinnersLink: 'Winners',

    // BandInvestSheet
    investSheetTitle: 'Invest in the raffle',
    investSheetLockedBody: 'Join SHOT BAND to invest in the weekly raffle.',
    investSheetJoinButton: 'Join',
    investSheetEndedBody: 'This round has ended — wait for the next one.',
    investSheetNoBalanceBody: 'Nothing to invest yet — complete daily quests to earn some.',
    investSheetDecrease: 'Decrease',
    investSheetIncrease: 'Increase',
    investSheetBalanceHint: '{{balance}} available',
    investSheetDisclaimer: 'Invested amounts are not returned — you can always add more.',
    investSheetErrorGeneric: 'Failed to invest. Try again.',
    investSheetSubmitButton: 'Invest',
  },
  ru: {
    title: 'SHOT BAND',
    loading: 'Загрузка SHOT BAND...',

    heroWelcome: 'Добро пожаловать в',
    heroMemberBadge: 'Ты в SHOT BAND',
    heroDaysLeftOne: 'Остался {{count}} день',
    heroDaysLeftFew: 'Осталось {{count}} дня',
    heroDaysLeftMany: 'Осталось {{count}} дней',
    heroDaysLeftZero: 'Членство заканчивается сегодня',
    heroRenewButton: 'Продлить',
    heroOfferTitlePrefix: 'Пополнение на',
    heroOfferTitleSuffix: 'включает клуб — здесь или в обычном пополнении.',
    heroOfferBody: 'Кешбэк до 4% — растёт с уровнем, ежедневные задания и шанс выиграть нож в розыгрыше.',
    heroOfferFinePrint: 'Вся сумма зачислится на твой игровой баланс. Ты сможешь тратить её на кейсы, контракты, игры и апгрейды как захочешь.',
    heroJoinButton: 'Вступить за',
    heroHowItWorks: 'Как это работает',

    rulesTitle: 'Как работает SHOT BAND',
    rule1Prefix: 'Закинь ',
    rule1Suffix: ' одним платежом — ты в SHOT BAND на 28 дней. Монеты придут на твой баланс, как обычно.',
    rule1Title: 'Вход в SHOT BAND',
    rule2Title: 'Кешбэк до 4%',
    rule2: 'Каждая игра за монеты возвращает кешбэк искрами. Процент растёт с уровнем — 1% на 10-м, 4% на 100-м. Забирай каждые 7 дней.',
    rule3Title: 'Кейсы за искры',
    rule3Prefix: 'Искры ',
    rule3Suffix: ' открывают кейсы SHOT BAND — внутри скины вплоть до ножей.',
    rule4Title: 'Задания и стрик',
    rule4Prefix: 'Ежедневные задания приносят ',
    rule4Mid: '. Держи стрик 7 дней — получишь +10 ',
    rule4Suffix: ' бонусом.',
    rule5Title: 'Розыгрыш ножа',
    rule5Prefix: 'Каждую неделю разыгрываем нож. Вкладывай ',
    rule5Suffix: ' — чем больше билетов, тем выше шанс.',
    rule6Title: 'Гонка дня',
    rule6: 'Наиграй за монеты больше всех до полуночи мск — и скин дня твой. Каждый день новый приз.',
    rule7Title: 'Кейсы бесплатно за оборот',
    rule7: 'Дневной оборот открывает кейсы полки бесплатно — чем больше играешь, тем дороже фри-кейс. Хоть все кейсы, хоть каждый день.',

    ticketSheetTitleJoin: 'Вступление в SHOT BAND',
    ticketSheetTitleRenew: 'Продление SHOT BAND',
    ticketSheetTopupNotePrefix: 'На баланс сразу зачислится',
    ticketSheetTopupNoteSuffix: '— клуб идёт подарком.',
    ticketSheetRenewDisclaimer: 'Продление добавится к текущему сроку членства — плюс 28 дней.',
    ticketSheetRenewTooEarly: 'Продление откроется за сутки до конца членства — загляни ближе к этому сроку.',
    ticketSheetBuyButton: 'Оплатить',
    ticketSheetLoadingProviders: 'Загружаем способы оплаты...',
    ticketSheetNoProviders: 'Сейчас нет доступных способов оплаты.',
    ticketSheetErrorTitle: 'Не получилось создать счёт',
    ticketSheetErrorHint: 'Попробуй ещё раз или выбери другой способ',
    ticketSheetLoadErrorGeneric: 'Не удалось загрузить способы оплаты.',
    ticketSheetPriceUnavailable: 'Цена недоступна для этого способа — выбери другой.',
    ticketSheetCardConfirmTitle: 'Подтверди оплату',
    ticketSheetCardConfirmMessage: 'Списать {{amount}} с карты {{card}} за пропуск в SHOT BAND?',
    ticketSheetCardConfirmOk: 'Оплатить',
    ticketSheetCardPending: 'Click ещё подтверждает платёж — членство включится автоматически.',
    ticketSheetCardErrorTitle: 'Оплата не прошла',
    ticketSheetCardErrorHint: 'Попробуй ещё раз; если деньги ушли с карты, напиши в поддержку',

    cashbackBalanceLabel: 'Баланс клуба',
    cashbackCoinsLabel: 'Искры',
    cashbackTicketsLabel: 'Билеты',
    cashbackNextPayoutLabel: 'Следующая выплата:',
    mechanicNameCase: 'Кейсы',
    mechanicNameBattle: 'Case Battles',
    mechanicNameRushMid: 'Rush Mid',
    mechanicNameRoulette: 'Рулетка',
    mechanicNameUpgrade: 'Upgrade',
    mechanicNameContract: 'Контракты',
    cashbackChipPrefix: 'кешбэк',
    cashbackChipLocked: 'кешбэк с {{level}} уровня',
    cashbackSpendButton: 'Потратить',
    cashbackInvestButton: 'Вложить',
    cashbackClaimReadyLabel: 'Кешбэк готов:',
    cashbackClaimButton: 'Забрать',
    cashbackTimerLabel: 'через',
    cashbackUnitDay: 'д',

    // BandStreak
    streakDayLabel: 'День {{day}} из 7',
    streakHint: '{{days}} дней подряд — бонус',

    // BandFreeCases
    freeCasesTitle: 'Бесплатный кейс',
    freeCasesTurnoverLabel: 'Оборот сегодня',
    freeCasesNextHintPrefix: 'Ещё',
    freeCasesNextHintSuffix: 'оборота — и откроешь его бесплатно',
    freeCasesReadyHint: 'Можно открыть бесплатно — забирай!',
    freeCasesAllClaimed: 'Всё бесплатное на сегодня открыто — новые после сброса',
    freeCasesTimerBurnOpen: 'Не откроешь до сброса — сгорит',
    freeCasesTimerBurnProgress: 'Прогресс оборота сгорит через',
    freeCasesTimerPlain: 'До сброса дня',
    freeCasesTimerNew: 'Новые бесплатные открытия через',
    freeCasesOpenFreeButton: 'Открыть',
    freeCasesRulesTitle: 'Правила бесплатного кейса',
    freeCasesRulesWagerTitle: 'Играй за монеты',
    freeCasesRulesWagerBody: 'Любая игра за монеты идёт в дневной оборот — кейсы, битвы, апгрейды, контракты, Rush Mid, рулетка.',
    freeCasesRulesOpenTitle: 'Взял порог — открываешь бесплатно',
    freeCasesRulesOpenBody: 'У каждого кейса свой порог оборота. Добрался — клуб платит за открытие. Одно бесплатное открытие на кейс в день.',
    freeCasesRulesResetTitle: 'В полночь всё сгорает',
    freeCasesRulesResetBody: 'В полночь по Москве день обнуляется: прогресс оборота и невзятые бесплатные открытия сгорают. Новый день — с нуля.',

    // BandQuests
    questsTitle: 'Задания дня',
    questsResetLabel: 'Новые задания через',
    questClaimButton: 'Забрать',
    questsLockedJoinButton: 'Вступить',
    questGenericTitle: 'Ежедневное задание',
    questCompletedToastOverline: 'Задание выполнено!',
    questGenericUnit: '',

    quest_open_3_cases_2500_prefix: 'Открой 3 кейса от',
    quest_open_3_cases_2500_suffix: '',
    quest_open_3_cases_2500_unit: 'кейса',
    quest_rush_3_matches_prefix: 'Сыграй 3 матча в Rush Mid',
    quest_rush_3_matches_unit: 'матча',
    quest_open_band_case_prefix: 'Открой кейс SHOT BAND',
    quest_open_band_case_unit: 'кейс',
    quest_wager_25k_prefix: 'Прокрути',
    quest_wager_25k_suffix: '',
    quest_battles_2_5k_prefix: 'Сыграй 2 баттла стоимостью от',
    quest_battles_2_5k_suffix: '',
    quest_battles_2_5k_unit: 'баттла',
    quest_upgrades_3_2500_prefix: 'Сделай 3 апгрейда от',
    quest_upgrades_3_2500_suffix: '',
    quest_upgrades_3_2500_unit: 'апгрейда',
    quest_contract_10k_prefix: 'Собери контракт от',
    quest_contract_10k_suffix: '',
    quest_contract_10k_unit: 'контракт',
    quest_win_battle_prefix: 'Выиграй баттл',
    quest_win_battle_unit: 'баттл',
    quest_win_upgrade_prefix: 'Выиграй апгрейд',
    quest_win_upgrade_unit: 'апгрейд',
    quest_open_case_12500_prefix: 'Открой кейс от',
    quest_open_case_12500_suffix: '',
    quest_open_case_12500_unit: 'кейс',
    quest_open_5_cases_1000_prefix: 'Открой 5 кейсов от',
    quest_open_5_cases_1000_suffix: '',
    quest_open_5_cases_1000_unit: 'кейсов',
    quest_roulette_play_prefix: 'Сыграй раунд рулетки',
    quest_roulette_play_unit: 'раунд',
    quest_contracts_25k_sum_prefix: 'Собери контрактов на',
    quest_contracts_25k_sum_suffix: '',
    quest_upgrades_15k_sum_prefix: 'Сделай апгрейдов на',
    quest_upgrades_15k_sum_suffix: '',
    quest_rush_5_matches_prefix: 'Сыграй 5 матчей Rush Mid',
    quest_rush_5_matches_unit: 'матчей',
    quest_wager_50k_prefix: 'Прокрути',
    quest_wager_50k_suffix: '',
    quest_wager_10k_battles_prefix: 'Прокрути',
    quest_wager_10k_battles_suffix: 'в баттлах',
    quest_wager_10k_rush_prefix: 'Прокрути',
    quest_wager_10k_rush_suffix: 'в Rush Mid',
    quest_wager_10k_roulette_prefix: 'Прокрути',
    quest_wager_10k_roulette_suffix: 'в рулетке',
    quest_wager_100k_prefix: 'Прокрути',
    quest_wager_100k_suffix: '',
    quest_rush_mid_win_prefix: 'Победи в Rush Mid',
    quest_rush_mid_win_unit: 'победа',
    quest_big_drop_25k_prefix: 'Выбей предмет дороже',
    quest_big_drop_25k_suffix: 'из кейса',
    quest_big_drop_25k_unit: 'предмет',
    quest_risky_upgrade_35_prefix: 'Выиграй апгрейд с шансом до 35%',
    quest_risky_upgrade_35_unit: 'апгрейд',
    quest_covert_drop_prefix: 'Выбей предмет Covert из кейса',
    quest_covert_drop_unit: 'предмет',

    // BandRaceSection
    raceTitle: 'Гонка дня',
    raceEmpty: 'Сегодня гонки нет — загляни позже',
    rulesLinkLabel: 'Правила',
    raceRulesTitle: 'Правила гонки дня',
    raceRulesPlayTitle: 'Как победить',
    raceRulesPlayBody: 'Играй во что угодно в SHOT — кейсы, апгрейды, контракты, баттлы, Rush Mid, рулетку. Считаются потраченные на игры монеты: у кого оборот за день больше всех — тот и победил.',
    raceRulesPrizeTitle: 'Приз',
    raceRulesPrizeBody: 'Каждый день — новый скин. В полночь по Москве он уходит первому месту и сразу падает в инвентарь.',
    raceRulesMembersTitle: 'Только для клуба',
    raceRulesMembersBody: 'Гонка — для членов SHOT BAND. Игра засчитывается автоматически, ничего включать не надо.',
    raffleRulesTitle: 'Правила розыгрыша недели',
    raffleRulesTicketsTitle: 'Получай билеты',
    raffleRulesTicketsBodyPrefix: 'Выполняй задания дня — за них дают билеты',
    raffleRulesTicketsBodySuffix: 'розыгрыша.',
    raffleRulesChanceTitle: 'Вкладывай и повышай шанс',
    raffleRulesChanceBody: 'Вкладывай билеты в раунд — чем больше вложил, тем выше шанс. Вложенное не возвращается, докидывать можно всегда.',
    raffleRulesFinalTitle: 'Финал',
    raffleRulesFinalBody: 'Раунд идёт неделю. Победителя выбирает случайность, скин сразу падает в инвентарь.',
    racePrizeLabel: 'Приз дня',
    raceYourPlace: 'Твоё место',
    raceParticipantsLabel: 'Участвует',
    raceNotWagered: 'Сыграй сегодня в любую игру — и ты в гонке',

    // BandRaffleSection
    raffleTitle: 'Розыгрыш недели',
    raffleEmpty: 'На этой неделе розыгрыша нет',
    raffleMyInvestedLabel: 'Вложено',
    raffleParticipantsLabel: 'Участвует',
    raffleParticipantOne: 'участник',
    raffleParticipantFew: 'участника',
    raffleParticipantMany: 'участников',
    raffleInvestButton: 'Вложить',
    raffleGoToQuestsButton: 'К заданиям',
    raffleEndedButton: 'Раунд завершён',
    raffleWinnersLink: 'Победители',

    // BandInvestSheet
    investSheetTitle: 'Вклад в розыгрыш',
    investSheetLockedBody: 'Вступи в SHOT BAND, чтобы вкладывать в еженедельный розыгрыш.',
    investSheetJoinButton: 'Вступить',
    investSheetEndedBody: 'Этот раунд уже завершён — дождись следующего.',
    investSheetNoBalanceBody: 'Пока нечего вкладывать — выполняй задания дня, чтобы получить.',
    investSheetDecrease: 'Уменьшить',
    investSheetIncrease: 'Увеличить',
    investSheetBalanceHint: 'Доступно: {{balance}}',
    investSheetDisclaimer: 'Вложенное не возвращается — довложить можно в любой момент.',
    investSheetErrorGeneric: 'Не удалось вложить. Попробуй ещё раз.',
    investSheetSubmitButton: 'Вложить',
  },
  uz: {
    title: 'SHOT BAND',
    loading: 'SHOT BAND yuklanmoqda...',

    heroWelcome: 'Xush kelibsan',
    heroMemberBadge: 'SHOT BAND aʼzosi',
    heroDaysLeftOne: '{{count}} kun qoldi',
    heroDaysLeftFew: '{{count}} kun qoldi',
    heroDaysLeftMany: '{{count}} kun qoldi',
    heroDaysLeftZero: 'Aʼzolik bugun tugaydi',
    heroRenewButton: 'Uzaytirish',
    heroOfferTitlePrefix: 'Hisob',
    heroOfferTitleSuffix: 'ga toʻldirish klubni yoqadi — shu yerda ham, oddiy toʻldirishda ham.',
    heroOfferBody: '4% gacha keshbek — daraja bilan oʻsadi, kunlik topshiriqlar va pichoq lotereyasi.',
    heroOfferFinePrint: 'Butun summa oʻyin balansingga tushadi. Uni keyslarga, kontraktlarga, oʻyinlarga va upgreydlarga xohlaganingcha sarflaysan.',
    heroJoinButton: 'Qoʻshilish —',
    heroHowItWorks: 'Bu qanday ishlaydi',

    rulesTitle: 'SHOT BAND qanday ishlaydi',
    rule1Prefix: 'Bir martalik ',
    rule1Suffix: " toʻlov bilan 28 kunga SHOT BANDʼga aʼzo boʻlasan. Tangalar odatdagidek balansingga tushadi.",
    rule1Title: 'Klubga kirish',
    rule2Title: '4% gacha keshbek',
    rule2: 'Tangaga har bir oʻyin uchqunlar bilan keshbek qaytaradi. Foiz daraja bilan oʻsadi — 10-darajada 1%, 100-darajada 4%. Har 7 kunda olib tur.',
    rule3Title: 'Uchqunga keyslar',
    rule3Prefix: 'Uchqunlar ',
    rule3Suffix: " SHOT BAND keyslarini ochadi — ichida pichoqlargacha skinlar.",
    rule4Title: 'Topshiriqlar va strik',
    rule4Prefix: 'Kunlik topshiriqlar ',
    rule4Mid: " beradi. 7 kunlik strikni saqla — bonus sifatida +10 ",
    rule4Suffix: '.',
    rule5Title: 'Pichoq lotereyasi',
    rule5Prefix: 'Har hafta pichoq oʻynaymiz. Oʻz ',
    rule5Suffix: 'laringni qoʻy — bilet koʻp boʻlsa, imkoniyat yuqori.',
    rule6Title: 'Kun poygasi',
    rule6: 'Yarim tungacha (MSK) tangaga eng koʻp oʻynagan kun skinini oladi. Har kuni yangi sovgʻa.',
    rule7Title: 'Aylanma uchun bepul keyslar',
    rule7: 'Kunlik aylanma keyslarni bepul ochadi — qancha koʻp oʻynasang, bepul keys shuncha qimmat. Har kuni, istalgan keysgacha.',

    ticketSheetTitleJoin: "SHOT BANDʼga qoʻshilish",
    ticketSheetTitleRenew: 'SHOT BAND aʼzoligini uzaytirish',
    ticketSheetTopupNotePrefix: 'Balansingga darhol',
    ticketSheetTopupNoteSuffix: 'tushadi — klub sovgʻa sifatida beriladi.',
    ticketSheetRenewDisclaimer: 'Uzaytirish joriy muddatga qoʻshiladi — plyus 28 kun.',
    ticketSheetRenewTooEarly: 'Uzaytirish aʼzolik tugashiga bir kun qolganda ochiladi — shu muddatga yaqinroq kel.',
    ticketSheetBuyButton: 'Toʻlash',
    ticketSheetLoadingProviders: 'Toʻlov usullari yuklanmoqda...',
    ticketSheetNoProviders: 'Hozircha toʻlov usullari mavjud emas.',
    ticketSheetErrorTitle: "Hisob yaratilmadi",
    ticketSheetErrorHint: 'Qayta urinib koʻr yoki boshqa usulni tanla',
    ticketSheetLoadErrorGeneric: 'Toʻlov usullarini yuklab boʻlmadi.',
    ticketSheetPriceUnavailable: 'Bu toʻlov usuli uchun narx mavjud emas — boshqasini tanla.',
    ticketSheetCardConfirmTitle: 'Toʻlovni tasdiqla',
    ticketSheetCardConfirmMessage: "SHOT BANDʼga qoʻshilish uchun {{card}} kartadan {{amount}} yechilsinmi?",
    ticketSheetCardConfirmOk: 'Toʻlash',
    ticketSheetCardPending: 'Click toʻlovni hali tasdiqlamoqda — aʼzolik avtomatik yoqiladi.',
    ticketSheetCardErrorTitle: 'Toʻlov oʻtmadi',
    ticketSheetCardErrorHint: 'Qayta urinib koʻr; pul kartadan yechilgan boʻlsa, qoʻllab-quvvatlashga yoz',

    cashbackBalanceLabel: 'Klub balansi',
    cashbackCoinsLabel: 'Uchqunlar',
    cashbackTicketsLabel: 'Chiptalar',
    cashbackNextPayoutLabel: 'Keyingi toʻlov:',
    mechanicNameCase: 'Keyslar',
    mechanicNameBattle: 'Battlar',
    mechanicNameRushMid: 'Rush Mid',
    mechanicNameRoulette: 'Ruletka',
    mechanicNameUpgrade: 'Upgrade',
    mechanicNameContract: 'Kontraktlar',
    cashbackChipPrefix: 'keshbek',
    cashbackChipLocked: 'keshbek {{level}}-darajadan',
    cashbackSpendButton: 'Sarflash',
    cashbackInvestButton: 'Qoʻyish',
    cashbackClaimReadyLabel: 'Keshbek tayyor:',
    cashbackClaimButton: 'Olish',
    cashbackTimerLabel: 'ichida',
    cashbackUnitDay: 'kun',

    // BandStreak
    streakDayLabel: '{{day}}-kun / 7 kun',
    streakHint: '{{days}} kun ketma-ket — bonus',

    // BandFreeCases
    freeCasesTitle: 'Bepul keys',
    freeCasesTurnoverLabel: 'Bugungi aylanma',
    freeCasesNextHintPrefix: 'Yana',
    freeCasesNextHintSuffix: "aylanma — va uni bepul ochasan",
    freeCasesReadyHint: 'Bepul ochish mumkin — ol!',
    freeCasesAllClaimed: "Bugungi barcha bepul ochishlar ishlatildi — yangilari yangilanishdan keyin",
    freeCasesTimerBurnOpen: "Ochmasang — yonib ketadi",
    freeCasesTimerBurnProgress: "Aylanma progressi yonib ketadi",
    freeCasesTimerPlain: 'Kun yangilanishigacha',
    freeCasesTimerNew: 'Yangi bepul ochishlar',
    freeCasesOpenFreeButton: 'Ochish',
    freeCasesRulesTitle: 'Bepul keys qoidalari',
    freeCasesRulesWagerTitle: 'Tangaga oʻyna',
    freeCasesRulesWagerBody: 'Tangaga har qanday oʻyin kunlik aylanmaga hisoblanadi — keyslar, janglar, upgreydlar, kontraktlar, Rush Mid, ruletka.',
    freeCasesRulesOpenTitle: 'Chegaraga yetding — bepul ochasan',
    freeCasesRulesOpenBody: 'Har bir keysning oʻz aylanma chegarasi bor. Yetib olding — ochish klub hisobidan. Har keysga kuniga bitta bepul ochish.',
    freeCasesRulesResetTitle: 'Yarim tunda hammasi yonadi',
    freeCasesRulesResetBody: "Moskva vaqti bilan yarim tunda kun yangilanadi: aylanma progressi va olinmagan bepul ochishlar yonib ketadi. Yangi kun — noldan.",

    // BandQuests
    questsTitle: 'Kunlik topshiriqlar',
    questsResetLabel: "Yangi topshiriqlargacha",
    questClaimButton: 'Olish',
    questsLockedJoinButton: 'Qoʻshilish',
    questGenericTitle: 'Kunlik topshiriq',
    questCompletedToastOverline: 'Topshiriq bajarildi!',
    questGenericUnit: '',

    quest_open_3_cases_2500_prefix: '',
    quest_open_3_cases_2500_suffix: "dan qimmat 3 ta keys och",
    quest_open_3_cases_2500_unit: 'keys',
    quest_rush_3_matches_prefix: "Rush Midʼda 3 ta matchda oʻyna",
    quest_rush_3_matches_unit: 'match',
    quest_open_band_case_prefix: 'SHOT BAND keysini och',
    quest_open_band_case_unit: 'keys',
    quest_wager_25k_prefix: '',
    quest_wager_25k_suffix: ' aylantir',
    quest_battles_2_5k_prefix: 'Kirish toʻlovi',
    quest_battles_2_5k_suffix: 'dan yuqori boʻlgan 2 ta jangda oʻyna',
    quest_battles_2_5k_unit: 'jang',
    quest_upgrades_3_2500_prefix: '',
    quest_upgrades_3_2500_suffix: 'dan qimmat 3 ta apgreyd qil',
    quest_upgrades_3_2500_unit: 'apgreyd',
    quest_contract_10k_prefix: '',
    quest_contract_10k_suffix: 'dan qimmat kontrakt tuz',
    quest_contract_10k_unit: 'kontrakt',
    quest_win_battle_prefix: 'Jangda gʻalaba qozon',
    quest_win_battle_unit: 'jang',
    quest_win_upgrade_prefix: 'Apgreydda yutib chiq',
    quest_win_upgrade_unit: 'apgreyd',
    quest_open_case_12500_prefix: '',
    quest_open_case_12500_suffix: 'dan qimmat keys och',
    quest_open_case_12500_unit: 'keys',
    quest_open_5_cases_1000_prefix: '',
    quest_open_5_cases_1000_suffix: 'dan qimmat 5 ta keys och',
    quest_open_5_cases_1000_unit: 'keys',
    quest_roulette_play_prefix: 'Ruletka turida oʻyna',
    quest_roulette_play_unit: 'tur',
    quest_contracts_25k_sum_prefix: 'Jami',
    quest_contracts_25k_sum_suffix: 'lik kontraktlar tuz',
    quest_upgrades_15k_sum_prefix: 'Jami',
    quest_upgrades_15k_sum_suffix: 'lik apgreydlar qil',
    quest_rush_5_matches_prefix: "Rush Midʼda 5 ta matchda oʻyna",
    quest_rush_5_matches_unit: 'match',
    quest_wager_50k_prefix: '',
    quest_wager_50k_suffix: ' aylantir',
    quest_wager_10k_battles_prefix: 'Janglarda',
    quest_wager_10k_battles_suffix: ' aylantir',
    quest_wager_10k_rush_prefix: "Rush Midʼda",
    quest_wager_10k_rush_suffix: ' aylantir',
    quest_wager_10k_roulette_prefix: 'Ruletkada',
    quest_wager_10k_roulette_suffix: ' aylantir',
    quest_wager_100k_prefix: '',
    quest_wager_100k_suffix: ' aylantir',
    quest_rush_mid_win_prefix: "Rush Midʼda gʻalaba qozon",
    quest_rush_mid_win_unit: 'gʻalaba',
    quest_big_drop_25k_prefix: 'Keysdan',
    quest_big_drop_25k_suffix: 'dan qimmat buyum tushir',
    quest_big_drop_25k_unit: 'buyum',
    quest_risky_upgrade_35_prefix: 'Ehtimolligi 35% gacha boʻlgan apgreydda yutib chiq',
    quest_risky_upgrade_35_unit: 'apgreyd',
    quest_covert_drop_prefix: 'Keysdan Covert buyum tushir',
    quest_covert_drop_unit: 'buyum',

    // BandRaceSection
    raceTitle: 'Kunlik poyga',
    raceEmpty: 'Bugun poyga yoʻq — keyinroq kir',
    rulesLinkLabel: 'Qoidalar',
    raceRulesTitle: 'Kunlik poyga qoidalari',
    raceRulesPlayTitle: 'Qanday gʻalaba qozonish',
    raceRulesPlayBody: "SHOTʼda istalgan oʻyinni oʻyna — keyslar, apgreydlar, kontraktlar, janglar, Rush Mid, ruletka. Oʻyinlarga sarflangan tangalar hisoblanadi: kunlik aylanmasi eng katta boʻlgan yutadi.",
    raceRulesPrizeTitle: 'Sovgʻa',
    raceRulesPrizeBody: 'Har kuni yangi skin. Yarim tunda (MSK) u birinchi oʻringa beriladi va darhol inventarga tushadi.',
    raceRulesMembersTitle: "Faqat klub uchun",
    raceRulesMembersBody: 'Poyga — SHOT BAND aʼzolari uchun. Oʻyin avtomatik hisoblanadi, hech narsani yoqish shart emas.',
    raffleRulesTitle: 'Haftalik lotereya qoidalari',
    raffleRulesTicketsTitle: 'Chiptalarni yig',
    raffleRulesTicketsBodyPrefix: 'Kunlik topshiriqlarni bajar — ular uchun lotereya chiptalari',
    raffleRulesTicketsBodySuffix: 'beriladi.',
    raffleRulesChanceTitle: 'Qoʻy va imkoniyatni oshir',
    raffleRulesChanceBody: 'Chiptalarni turga qoʻy — qancha koʻp qoʻysang, imkoniyat shuncha yuqori. Qoʻyilganlar qaytarilmaydi, yana qoʻshish mumkin.',
    raffleRulesFinalTitle: 'Final',
    raffleRulesFinalBody: 'Tur bir hafta davom etadi. Gʻolibni tasodif tanlaydi, skin darhol inventarga tushadi.',
    racePrizeLabel: 'Kun sovgʻasi',
    raceYourPlace: 'Sening oʻrning',
    raceParticipantsLabel: 'Ishtirok etyapti',
    raceNotWagered: 'Bugun istalgan oʻyinni oʻyna — va sen poygadasan',

    // BandRaffleSection
    raffleTitle: 'Haftalik lotereya',
    raffleEmpty: 'Bu hafta lotereya yoʻq',
    raffleMyInvestedLabel: 'Qoʻyilgan',
    raffleParticipantsLabel: 'Ishtirok etyapti',
    raffleParticipantOne: 'ishtirokchi',
    raffleParticipantFew: 'ishtirokchi',
    raffleParticipantMany: 'ishtirokchi',
    raffleInvestButton: 'Qoʻyish',
    raffleGoToQuestsButton: 'Topshiriqlarga',
    raffleEndedButton: 'Tur tugadi',
    raffleWinnersLink: 'Gʻoliblar',

    // BandInvestSheet
    investSheetTitle: 'Lotereyaga qoʻyish',
    investSheetLockedBody: "Haftalik lotereyaga qoʻyish uchun SHOT BANDʼga qoʻshil.",
    investSheetJoinButton: 'Qoʻshilish',
    investSheetEndedBody: 'Bu tur allaqachon tugadi — keyingisini kut.',
    investSheetNoBalanceBody: 'Hozircha qoʻyadigan narsa yoʻq — kunlik topshiriqlarni bajarib ol.',
    investSheetDecrease: 'Kamaytirish',
    investSheetIncrease: 'Oshirish',
    investSheetBalanceHint: 'Mavjud: {{balance}}',
    investSheetDisclaimer: 'Qoʻyilganlar qaytarilmaydi — istalgan payt yana qoʻshishing mumkin.',
    investSheetErrorGeneric: 'Qoʻyib boʻlmadi. Qayta urinib koʻr.',
    investSheetSubmitButton: 'Qoʻyish',
  },
  fa: {
    title: 'SHOT BAND',
    loading: 'در حال بارگذاری SHOT BAND...',

    // BandHero — member
    heroWelcome: 'خوش آمدی به',
    heroMemberBadge: 'عضو SHOT BAND',
    heroDaysLeftOne: '{{count}} روز مانده',
    heroDaysLeftFew: '{{count}} روز مانده',
    heroDaysLeftMany: '{{count}} روز مانده',
    heroDaysLeftZero: 'عضویت امروز تمام می‌شود',
    heroRenewButton: 'تمدید',
    // BandHero — non-member
    heroOfferTitlePrefix: '',
    heroOfferTitleSuffix: 'شارژ کن تا باشگاه روشن شود — همین‌جا یا در هر شارژی.',
    heroOfferBody: 'کش‌بک تا 4% — با سطحت بالا می‌رود — مأموریت روزانه و شانس قرعه‌کشی چاقو.',
    heroOfferFinePrint: 'کل مبلغ روی موجودی بازیت می‌نشیند. هرطور خواستی خرجش کن: کیس، قرارداد، بازی و ارتقا.',
    heroJoinButton: 'عضو شو با',
    heroHowItWorks: 'چطور کار می‌کند',

    // BandRulesSheet
    rulesTitle: 'SHOT BAND چطور کار می‌کند',
    rule1Prefix: '',
    rule1Suffix: ' را یک‌جا شارژ کن — 28 روز عضو SHOT BAND هستی. سکه‌ها مثل همیشه به موجودیت می‌آیند.',
    rule1Title: 'عضویت در SHOT BAND',
    rule2Title: 'کش‌بک تا 4%',
    rule2:
      'هر بازی سکه‌ای کش‌بک می‌دهد، به شکل جرقه. نرخش با سطحت بالا می‌رود — 1% در سطح 10، 4% در سطح 100. هر 7 روز بگیرش.',
    rule3Title: 'کیس با جرقه',
    rule3Prefix: '',
    rule3Suffix: ' کیس‌های SHOT BAND را باز می‌کند — اسکین تا خود چاقو.',
    rule4Title: 'مأموریت و زنجیره',
    rule4Prefix: 'مأموریت‌های روزانه ',
    rule4Mid: ' می‌دهند. زنجیره 7 روزه را نگه دار — +10 ',
    rule4Suffix: ' بونوس بگیر.',
    rule5Title: 'قرعه‌کشی هفتگی چاقو',
    rule5Prefix: 'هر هفته یک چاقو قرعه‌کشی می‌کنیم. ',
    rule5Suffix: ' خودت را سرمایه‌گذاری کن — بلیت بیشتر، شانس بیشتر.',
    rule6Title: 'رقابت روزانه',
    rule6: 'تا نیمه‌شب (به وقت مسکو) بیشترین سکه را بازی کن و اسکین آن روز را ببر. هر روز، جایزه‌ای تازه.',
    rule7Title: 'کیس رایگان برای گردش',
    rule7:
      'گردش روزانه‌ات کیس‌های قفسه را رایگان باز می‌کند — هرچه بیشتر بازی کنی، کیس رایگان بهتری می‌گیری. تا سقف همه کیس‌ها، هر روز.',

    // BandTicketSheet
    ticketSheetTitleJoin: 'عضویت در SHOT BAND',
    ticketSheetTitleRenew: 'تمدید SHOT BAND',
    ticketSheetTopupNotePrefix: 'همان لحظه',
    ticketSheetTopupNoteSuffix: 'به موجودیت می‌نشیند — باشگاه هدیه است.',
    ticketSheetRenewDisclaimer: 'تمدید 28 روز به مدت عضویت فعلیت اضافه می‌کند.',
    ticketSheetRenewTooEarly: 'تمدید یک روز پیش از پایان عضویت باز می‌شود — نزدیک آن تاریخ برگرد.',
    ticketSheetBuyButton: 'پرداخت',
    ticketSheetLoadingProviders: 'در حال بارگذاری روش‌های پرداخت...',
    ticketSheetNoProviders: 'الان روش پرداختی در دسترس نیست.',
    ticketSheetErrorTitle: 'فاکتور ساخته نشد',
    ticketSheetErrorHint: 'دوباره تلاش کن یا روش دیگری انتخاب کن',
    ticketSheetLoadErrorGeneric: 'روش‌های پرداخت بارگذاری نشدند.',
    ticketSheetPriceUnavailable: 'برای این روش پرداخت قیمتی نیست — یکی دیگر امتحان کن.',
    ticketSheetCardConfirmTitle: 'تأیید پرداخت',
    ticketSheetCardConfirmMessage: 'برای عضویت در SHOT BAND، {{amount}} از {{card}} کسر شود؟',
    ticketSheetCardConfirmOk: 'پرداخت',
    ticketSheetCardPending: 'Click هنوز پرداخت را تأیید می‌کند — عضویتت خودکار روشن می‌شود.',
    ticketSheetCardErrorTitle: 'پرداخت انجام نشد',
    ticketSheetCardErrorHint: 'دوباره تلاش کن؛ اگر پول از کارتت کم شد با پشتیبانی تماس بگیر',

    // BandCashback
    cashbackBalanceLabel: 'موجودی باشگاه',
    cashbackCoinsLabel: 'جرقه',
    cashbackTicketsLabel: 'بلیت',
    cashbackNextPayoutLabel: 'پرداخت بعدی:',
    mechanicNameCase: 'کیس‌ها',
    mechanicNameBattle: 'نبردها',
    mechanicNameRushMid: 'Rush Mid',
    mechanicNameRoulette: 'رولت',
    mechanicNameUpgrade: 'ارتقاها',
    mechanicNameContract: 'قراردادها',
    cashbackChipPrefix: 'کش‌بک',
    cashbackChipLocked: 'کش‌بک از سطح {{level}}',
    cashbackSpendButton: 'خرج کن',
    cashbackInvestButton: 'سرمایه‌گذاری',
    cashbackClaimReadyLabel: 'کش‌بک آماده است:',
    cashbackClaimButton: 'بگیر',
    cashbackTimerLabel: 'تا',
    cashbackUnitDay: 'روز',

    // BandStreak
    streakDayLabel: 'روز {{day}} از 7',
    streakHint: '{{days}} روز پشت سر هم — بونوس',

    // BandFreeCases
    freeCasesTitle: 'کیس رایگان',
    freeCasesTurnoverLabel: 'گردش امروز',
    freeCasesNextHintPrefix: '',
    freeCasesNextHintSuffix: 'دیگر بازی کن تا رایگان بازش کنی',
    freeCasesReadyHint: 'رایگان است — بازش کن!',
    freeCasesAllClaimed: 'همه بازکردن‌های رایگان امروز خرج شد — بعد از ریست تازه می‌شوند',
    freeCasesTimerBurnOpen: 'بازکردن رایگان با ریست می‌سوزد',
    freeCasesTimerBurnProgress: 'پیشرفت گردش با ریست می‌سوزد',
    freeCasesTimerPlain: 'ریست روز تا',
    freeCasesTimerNew: 'بازکردن‌های رایگان تازه تا',
    freeCasesOpenFreeButton: 'باز کن',
    freeCasesRulesTitle: 'قوانین کیس رایگان',
    freeCasesRulesWagerTitle: 'با سکه بازی کن',
    freeCasesRulesWagerBody:
      'هر بازی سکه‌ای در گردش روزانه‌ات حساب می‌شود — کیس، نبرد، ارتقا، قرارداد، Rush Mid، رولت.',
    freeCasesRulesOpenTitle: 'به آستانه برس — رایگان باز کن',
    freeCasesRulesOpenBody:
      'هر کیس آستانه گردش خودش را دارد. بهش برسی، باشگاه هزینه بازکردن را می‌دهد. هر کیس، روزی یک بازکردن رایگان.',
    freeCasesRulesResetTitle: 'نیمه‌شب همه‌چیز می‌سوزد',
    freeCasesRulesResetBody:
      'نیمه‌شب (به وقت مسکو) روز ریست می‌شود: پیشرفت گردش و بازکردن‌های رایگان نگرفته می‌سوزند. روز بعد از صفر.',

    // BandQuests
    questsTitle: 'مأموریت‌های روزانه',
    questsResetLabel: 'مأموریت‌های تازه تا',
    questClaimButton: 'بگیر',
    questsLockedJoinButton: 'عضو شو',
    questGenericTitle: 'مأموریت روزانه',
    questCompletedToastOverline: 'مأموریت انجام شد!',
    questGenericUnit: '',

    quest_open_3_cases_2500_prefix: '3 کیس',
    quest_open_3_cases_2500_suffix: 'به بالا باز کن',
    quest_open_3_cases_2500_unit: 'کیس',
    quest_rush_3_matches_prefix: '3 مسابقه Rush Mid بازی کن',
    quest_rush_3_matches_unit: 'مسابقه',
    quest_open_band_case_prefix: 'یک کیس SHOT BAND باز کن',
    quest_open_band_case_unit: 'کیس',
    quest_wager_25k_prefix: '',
    quest_wager_25k_suffix: 'بازی کن',
    quest_battles_2_5k_prefix: '2 نبرد کیس با ورودی',
    quest_battles_2_5k_suffix: 'به بالا بازی کن',
    quest_battles_2_5k_unit: 'نبرد',
    quest_upgrades_3_2500_prefix: '3 ارتقا به ارزش',
    quest_upgrades_3_2500_suffix: 'به بالا بزن',
    quest_upgrades_3_2500_unit: 'ارتقا',
    quest_contract_10k_prefix: 'یک قرارداد به ارزش',
    quest_contract_10k_suffix: 'به بالا ببند',
    quest_contract_10k_unit: 'قرارداد',
    quest_win_battle_prefix: 'یک نبرد کیس ببر',
    quest_win_battle_unit: 'نبرد',
    quest_win_upgrade_prefix: 'یک ارتقا ببر',
    quest_win_upgrade_unit: 'ارتقا',
    quest_open_case_12500_prefix: 'یک کیس به ارزش',
    quest_open_case_12500_suffix: 'به بالا باز کن',
    quest_open_case_12500_unit: 'کیس',
    quest_open_5_cases_1000_prefix: '5 کیس',
    quest_open_5_cases_1000_suffix: 'به بالا باز کن',
    quest_open_5_cases_1000_unit: 'کیس',
    quest_roulette_play_prefix: 'یک دور رولت بازی کن',
    quest_roulette_play_unit: 'دور',
    quest_contracts_25k_sum_prefix: 'روی‌هم قرارداد به ارزش',
    quest_contracts_25k_sum_suffix: 'ببند',
    quest_upgrades_15k_sum_prefix: 'روی‌هم ارتقا به ارزش',
    quest_upgrades_15k_sum_suffix: 'بزن',
    quest_rush_5_matches_prefix: '5 مسابقه Rush Mid بازی کن',
    quest_rush_5_matches_unit: 'مسابقه',
    quest_wager_50k_prefix: '',
    quest_wager_50k_suffix: 'بازی کن',
    quest_wager_10k_battles_prefix: '',
    quest_wager_10k_battles_suffix: 'در نبرد کیس بازی کن',
    quest_wager_10k_rush_prefix: '',
    quest_wager_10k_rush_suffix: 'در Rush Mid بازی کن',
    quest_wager_10k_roulette_prefix: '',
    quest_wager_10k_roulette_suffix: 'در رولت بازی کن',
    quest_wager_100k_prefix: '',
    quest_wager_100k_suffix: 'بازی کن',
    quest_rush_mid_win_prefix: 'یک مسابقه Rush Mid ببر',
    quest_rush_mid_win_unit: 'برد',
    quest_big_drop_25k_prefix: 'از یک کیس آیتمی گران‌تر از',
    quest_big_drop_25k_suffix: 'در بیاور',
    quest_big_drop_25k_unit: 'آیتم',
    quest_risky_upgrade_35_prefix: 'یک ارتقا با شانس 35% یا کمتر ببر',
    quest_risky_upgrade_35_unit: 'ارتقا',
    quest_covert_drop_prefix: 'از یک کیس آیتم Covert در بیاور',
    quest_covert_drop_unit: 'آیتم',

    // BandRaceSection
    raceTitle: 'رقابت روزانه',
    raceEmpty: 'امروز رقابتی نیست — بعداً سر بزن',
    rulesLinkLabel: 'قوانین',
    raceRulesTitle: 'قوانین رقابت روزانه',
    raceRulesPlayTitle: 'چطور ببریم',
    raceRulesPlayBody:
      'هر چیزی در SHOT بازی کن — کیس، ارتقا، قرارداد، نبرد، Rush Mid، رولت. سکه‌ای که خرج بازی می‌کنی حساب می‌شود: بیشترین گردش روزانه می‌برد.',
    raceRulesPrizeTitle: 'جایزه',
    raceRulesPrizeBody:
      'هر روز یک اسکین تازه. نیمه‌شب (به وقت مسکو) به نفر اول می‌رسد و مستقیم در انبارش می‌افتد.',
    raceRulesMembersTitle: 'فقط اعضا',
    raceRulesMembersBody: 'رقابت برای اعضای SHOT BAND است. بازیت خودکار حساب می‌شود — چیزی لازم نیست فعال کنی.',
    raffleRulesTitle: 'قوانین قرعه‌کشی هفتگی',
    raffleRulesTicketsTitle: 'بلیت جمع کن',
    raffleRulesTicketsBodyPrefix: 'مأموریت‌های روزانه را انجام بده تا بلیت قرعه‌کشی بگیری',
    raffleRulesTicketsBodySuffix: '',
    raffleRulesChanceTitle: 'سرمایه‌گذاری کن تا شانست بالا برود',
    raffleRulesChanceBody:
      'بلیت‌ها را در دور سرمایه‌گذاری کن — هرچه بیشتر بگذاری، شانست بیشتر است. بلیت سرمایه‌گذاری‌شده برنمی‌گردد، اما همیشه می‌توانی بیشتر بگذاری.',
    raffleRulesFinalTitle: 'فینال',
    raffleRulesFinalBody: 'هر دور یک هفته است. برنده تصادفی انتخاب می‌شود و اسکین مستقیم در انبارش می‌افتد.',
    racePrizeLabel: 'جایزه امروز',
    raceYourPlace: 'جایگاه تو',
    raceParticipantsLabel: 'در حال بازی',
    raceNotWagered: 'امروز هر چیزی بازی کن تا وارد رقابت شوی',

    // BandRaffleSection
    raffleTitle: 'قرعه‌کشی هفتگی',
    raffleEmpty: 'این هفته قرعه‌کشی در جریان نیست',
    raffleMyInvestedLabel: 'سرمایه‌گذاری تو',
    raffleParticipantsLabel: 'در حال بازی',
    raffleParticipantOne: 'شرکت‌کننده',
    raffleParticipantFew: 'شرکت‌کننده',
    raffleParticipantMany: 'شرکت‌کننده',
    raffleInvestButton: 'سرمایه‌گذاری',
    raffleGoToQuestsButton: 'رفتن به مأموریت‌ها',
    raffleEndedButton: 'دور تمام شد',
    raffleWinnersLink: 'برندگان',

    // BandInvestSheet
    investSheetTitle: 'سرمایه‌گذاری در قرعه‌کشی',
    investSheetLockedBody: 'برای سرمایه‌گذاری در قرعه‌کشی هفتگی به SHOT BAND بپیوند.',
    investSheetJoinButton: 'عضو شو',
    investSheetEndedBody: 'این دور تمام شد — منتظر دور بعدی بمان.',
    investSheetNoBalanceBody: 'هنوز چیزی برای سرمایه‌گذاری نداری — مأموریت‌های روزانه را انجام بده.',
    investSheetDecrease: 'کم کن',
    investSheetIncrease: 'زیاد کن',
    investSheetBalanceHint: '{{balance}} در دسترس',
    investSheetDisclaimer: 'مبلغ سرمایه‌گذاری‌شده برنمی‌گردد — همیشه می‌توانی بیشتر بگذاری.',
    investSheetErrorGeneric: 'سرمایه‌گذاری نشد. دوباره تلاش کن.',
    investSheetSubmitButton: 'سرمایه‌گذاری',
  },
});
